import React from 'react';
import { WeeklyProductivityChart, ChartWidget } from '../charts/ChartPrototypes';

const WeeklyProductivityWidget: React.FC = () => {
  return (
    <ChartWidget title="My Weekly Productivity (Trailing 8 Weeks)" className="h-full">
      <WeeklyProductivityChart />
    </ChartWidget>
  );
};

export default WeeklyProductivityWidget;
